"use strict"

import React, { useEffect, useState } from "react"
import { withAppSettingsConfig } from "../../config/AppSettingsConfigProvider"
import GenerateDropdown from "../../shared_components/widgets/GenerateDropdown"
import { updateObject } from "../../Loaders"
import { logToServer } from "../../ErrorBoundary"

function _ToggleLanguageButton(props) {
  const { setPreferredLanguage, reloadConfig } = props
  const [selectedLang, setSelectedLang] = useState("en")
  const [languages, setLanguages] = useState([])
  const [user, setUser] = useState(null)
  const [warning, setWarning] = useState(false)

  useEffect(() => {
    setSelectedLang(props.config.locale)
    setLanguages(props.config.locales_supported)
    setUser(props.config.user)
  }, [props.config])

  const toggleLanguage = (e, lang) => {
    e.preventDefault()
    if (lang !== selectedLang) {
      setPreferredLanguage(lang)
      updateObject(`/users/list/${user.id}/language_preference/`, { lang: lang })
        .then((_) => {
          setUser(_)
          reloadConfig()
          setWarning(false)
        })
        .catch((err) => {
          console.error(err)
          logToServer(err)
          setWarning(true)
        })
    }
  }

  return (
    <div>
      {user && languages.length > 0 ? (
        <GenerateDropdown
          title={selectedLang}
          id={"language-selector"}
          list={languages}
          onClickFunc={toggleLanguage}
        />
      ) : (
        <></>
      )}
    </div>
  )
}

const ToggleLanguageButton = withAppSettingsConfig(_ToggleLanguageButton)
export default ToggleLanguageButton
